import { render, staticRenderFns } from "./ProjectTeamMembers.vue?vue&type=template&id=1edffd12"
import script from "./ProjectTeamMembers.vue?vue&type=script&lang=js"
export * from "./ProjectTeamMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports